import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface modalStates {
  loginModal: boolean;
}

const initialState: modalStates = {
  loginModal: false,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    toggleLoginModal: (state, action: PayloadAction<boolean>) => {
      state.loginModal = action.payload;
    },
  },
  extraReducers: (builder) => { },
})

export const {
  toggleLoginModal,
} = modalSlice.actions;
export default modalSlice.reducer;
